<template>
  <button class="print_btn" @click="printDataGrid">列印</button>
</template>

<script setup>
import { onMounted, ref } from 'vue';
const props = defineProps(['datagrid']);

const grid_data = ref([]);
onMounted(() => {
  grid_data.value = getData();
});
const shipReceive = {
  printDataGrid() {
    // create a new tab in browser
    const printWindow = window.open('', '_blank');
    // HTML template
    const printContent = `
  <html>
    <head>
      <style>
      @media print {
          title, head {
            display: none;
          }
        }

        h2 {
          text-align: center;
        }

        .bottom_info_title {
          text-align: center;
          padding: 10px;
          border-right: 1px solid black;
          border-left: 1px solid black;
          font-weight: 700;
        }
        .print_info p{
          margin:5px 0
        }

        .info_wrap_top {
          display: flex;
          border: 1px solid black;
        }
        .info_wrap_bottom{
          display:flex; border-bottom: 1px solid black;   border-right: 1px solid black; border-left: 1px solid black;
        }

        .left_col {
          justify-content: center;
          width: 100px;
          text-align: center;
          border-right: 1px solid black;
          padding: 10px;
          display: flex;
          height: auto;
          align-items: center;
        }
        .info_wrap_bottom .left_col{
          height:100px
        }
        .right_col {
          padding: 5px 20px;
        }
      </style>
      <title>出貨簽收單</title>
    </head>
    <body>
      <h2>出貨簽收單</h2>
      <img src='https://www.bimfm.com.tw/image/logo.png' style='width: 180px; margin: 10px 0'>
      <div class='print_info' style='display: flex;flex-direction:column; gap: 0 20px;'>
        <p style='font-size: 14px'>單號：12345678902</p>
        <p style='font-size: 14px'>專案名稱：長佳TPKC資料中心IDC及MSC機房機電新建工程BIM服務</p>
        <p style='font-size: 14px'>廠商名稱：三星電子</p>
        <p style='font-size: 14px'>承辦人：蕭敬騰</p>
        <p style='font-size: 14px'>日期：2022/01/01</p>
      </div>
      <table style="width: 100%; border-collapse: collapse; border: 1px solid black;">
        <thead>
          <tr>
            <th style="border: 1px solid black; font-size: 12px;"></th>
            <th style="border: 1px solid black; font-size: 12px;">序號</th>
            <th style="border: 1px solid black;font-size:12px">物品名稱</th>
            <th style="border: 1px solid black;font-size:12px">廠商</th>
            <th style="border: 1px solid black;font-size:12px">型號</th>
            <th style="border: 1px solid black;font-size:12px">規格</th>
            <th style="border: 1px solid black;font-size:12px">數量</th>
            <th style="border: 1px solid black;font-size:12px">單位</th>
          </tr>
        </thead>
        <tbody>
          ${this.getPrintableData()}
        </tbody>
      </table>
      <div class='bottom_info_title'>請收貨單位驗收物品後填寫下欄，此簽收單由本公司收存</div>
      <div class='row info_wrap_top'>
        <div class='left_col'>
          簽收欄
        </div>
        <div class='col-auto right_col'>
          <p>以上貨物已於西元<span style='width: 60px; display: inline-block;'></span>年<span style='width: 60px; display: inline-block;'></span>月<span style='width: 60px; display: inline-block;'></span>日清點及交付無誤。</p>
          <p>收貨單位：</p>
          <p>收貨人簽章：</p>
        </div>
      </div>
      <div class='row info_wrap_bottom' >
        <div class=' left_col'>
          備註
        </div>
        <div class='col-auto right_col'>
          
        </div>
      </div>
    </body>
  </html>
    `;
    printWindow.document.write(printContent);

    // 觸發列印功能
    printWindow.print();
  },
  getPrintableData() {
    return grid_data.value.map((item, index) =>
      `
        <tr>
          <td style="border: 1px solid black; font-size: 12px;padding:5px;  text-align: center;">${(index + 1).toString().padStart(2, '0')}</td>
          <td style="border: 1px solid black;font-size:12px;padding:5px">${item.AssetsId}</td>
          <td style="border: 1px solid black;font-size:12px;padding:5px">${item.AssetName}</td>
          <td style="border: 1px solid black;font-size:12px;padding:5px">${item.Manufacturer}</td>
          <td style="border: 1px solid black;font-size:12px;padding:5px">${item.Model}</td>
          <td style="border: 1px solid black;font-size:12px;padding:5px">${item.Specification}</td>
          <td style="border: 1px solid black;font-size:12px;padding:5px">${item.Quantity}</td>
          <td style="border: 1px solid black;font-size:12px;padding:5px">${item.Unit}</td>
        </tr>
       `)
      .join('');
  },
  getData() {
    return Array.from({ length: 5 }, (_, index) => ({
      SerialNumber: (index + 1).toString().padStart(2, '0'),
      AssetsId: 'BF00001186',
      AssetName: '滑鼠滑鼠滑鼠滑鼠滑鼠滑鼠滑鼠滑鼠滑鼠滑鼠',
      Manufacturer: 'LG',
      Model: 'S156498',
      Specification: '黑色 100g',
      Quantity: 200,
      Unit: '模',
    }));    // Generate sample data for demonstration
  }
}
const printDataGrid = () => {
  // create a new tab in browser
  const printWindow = window.open('', '_blank');
  // HTML template
  const printContent = `
  <html>
    <head>
      <style>
      @media print {
          title, head {
            display: none;
          }
        }

        h2 {
          text-align: center;
        }

        .bottom_info_title {
          text-align: center;
          padding: 10px;
          border-right: 1px solid black;
          border-left: 1px solid black;
          font-weight: 700;
        }
        .print_info p{
          margin:5px 0
        }

        .info_wrap_top {
          display: flex;
          justify-content: space-between;
          border: 1px solid black;
          border-top: 0;
          width: 1436px;  
        }
        .info_wrap_bottom{
          display:flex; border-bottom: 1px solid black;
          border-right: 1px solid black; border-left: 1px solid black;
        }

        .left_col {
          justify-content: center;
          width: 168px;
          text-align: center;
          border-right: 1px solid black;
          padding: 10px;
          display: flex;
          height: auto;
          align-items: center;
        }
        .right_col {
          padding: 0px 20px;
        }
        .half-row {
        }
        .half-row-title {
          align-items: center;
          height: 50px;
          padding: 10px 13px;
        }
        .d-flex {
          display: flex;
        }
        .green-bg {
          
        }
        .space {
          width: 489px;
        }
        .border-bottom {
          border-bottom: 1px solid black;
        }
        .border-right {
          border-right: 1px solid black;
        }
        .border-left {
          border-left: 1px solid black;
        }
        td,th {
          border: 1px solid black;
          padding:5px;
          font-size: 12px;
          break-inside: avoid;
        }
        
      </style>
      <title>&emsp;</title>
    </head>
    <body>
      <h2>資產交還單</h2>
      <div class='print_info' style='display: flex;flex-direction:column; gap: 0 20px;'>
        <p style='font-size: 14px'>接收人員：---</p>
        <p style='font-size: 14px'>交還人員：蕭敬騰</p>
        <p style='font-size: 14px'>交還原因：回歸祖國</p>
        <p style='font-size: 14px'>備&emsp;&emsp;註：說明說明說明說明說明說明說明說明說明說明說明說明說明</p>
      </div>
      <table style="border-collapse: collapse; border: 1px solid black;">
        <thead>
          <tr>
            <th style="width: 45px;">項次</th>
            <th style="width: 45px;">歸還</th>
            <th style="width: 90px;">資產編號</th>
            <th style="width: 250px;">物品名稱</th>
            <th style="width: 90px;">資產狀態</th>
            <th style="width: 100px;">儲位區域</th>
            <th style="width: 100px;">儲位櫃位</th>
            <th style="width: 80px;">廠商</th>
            <th style="width: 120px;">型號</th>
            <th style="width: 140px;">規格</th>
            <th style="width: 45px;">數量</th>
            <th style="width: 40px;">單位</th>
            <th style="width: 150px;">備註</th>
            <th style="width: 100px;">簽名</th>
          </tr>
        </thead>
        <tbody>
          ${getPrintableData()}
          <tr>
            <td colspan="3" rowspan="2" style="height: 150px">備註</td>
            <td colspan="5" rowspan="2"></td>
            <td>交還人員簽名</td>
            <td colspan="5"></td>
          </tr>
          <tr>
            <td>接收人員簽名</td>
            <td colspan="5"></td>
          </tr>
        </tbody>
      </table>
    </body>
  </html>
    `;
  printWindow.document.write(printContent);
  printWindow.print();
};
const getPrintableData = () => {
  return grid_data.value.map((item, index) =>
    `
        <tr>
          <td style="text-align: center;">${(index + 1).toString().padStart(2, '0')}</td>
          <td style="text-align: center;"><input type="checkbox"></td>
          <td style="">${item.AssetsId}</td>
          <td style="">${item.AssetName}</td>
          <td style="">${item.Status}</td>
          <td style="">${item.AreaName}</td>
          <td style="">${item.LayerName}</td>
          <td style="">${item.VendorName}</td>
          <td style="">${item.ProductType}</td>
          <td style="">${item.ProductSpec}</td>
          <td style="">${item.Number}</td>
          <td style="">${item.Unit}</td>
          <td style="">&emsp;&emsp;&emsp;&emsp;&emsp;</td>
          <td style="">&emsp;&emsp;&emsp;</td>
        </tr>
       `)
    .join('');
};
const getData = () => {
  return Array.from({ length: 15 }, (_, index) => ({
    SerialNumber: (index + 1).toString().padStart(2, '0'),
    AssetsId: 'BF12345678',
    AssetName: '一二三四五六七八九十',
    Status: '已被設備整合',
    AreaName: '3A辦公空間',
    LayerName: '技術總監辦公室',
    VendorName: 'ASUS',
    ProductType: 'ASUS 01845',
    ProductSpec: '24吋/100-240V/1.5A',
    Number: 100,
    Unit: '個',
  }));    // Generate sample data for demonstration
};

</script>


<style lang="scss" scoped>
@import "@/assets/css/global.scss";

button.print_btn {
  margin-left: 10px;
  @include search_and_send_btn;

  &:hover {
    background-color: #5e7aa2;
  }
}
</style>